export const COMPENSATORY_TIME_OFF_REQUESTS_PATH =
  "/requests/compensatory-time-off";
